import * as yup from 'yup'

import {
  departmentSchema,
  dobSchema,
  emailSchema,
  facilitySchema,
  firstNameSchema,
  genderSchema,
  lastNameShema,
  otherNameSchema,
  phoneNumberSchema,
  roleSchema,
  specialtySchema
} from './userSchema'

export const addStaffSchema = yup.object({
  date_of_birth: dobSchema,
  department: departmentSchema,
  email: emailSchema,
  first_name: firstNameSchema,
  facility: facilitySchema,
  gender: genderSchema,
  last_name: lastNameShema,
  middle_name: otherNameSchema,
  phone_number: phoneNumberSchema,
  role: roleSchema,
  specialty: specialtySchema
})

export const editStaffSchema = yup.object({
  email: emailSchema,
  phone_number: phoneNumberSchema
  // department: departmentSchema,
  // role: roleSchema,
  // employment_type: employment_typeSchema,
  // specialty: specialtySchema
})
